import React, { Component } from 'react';
import SignaturePad from 'signature_pad';
import './signaturefield.css';

/*
 * Wraps the signature_pad library as a form field. Emits the drawn signature
 * as a PNG data URL via onSignatureChange(fieldId, fieldName, dataUrl).
 * An empty pad emits "" so required-validation can treat it as missing.
 */
export class SignatureField extends Component {
    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
    }

    componentDidMount() {
        this.signaturePad = new SignaturePad(this.canvasRef.current, {
            backgroundColor: 'rgb(255, 255, 255)',
            penColor: 'rgb(0, 0, 0)'
        });
        this.signaturePad.addEventListener('endStroke', this.handleEnd);
    }

    componentWillUnmount() {
        if (this.signaturePad) {
            this.signaturePad.removeEventListener('endStroke', this.handleEnd);
        }
    }

    handleEnd = () => {
        this.emit(this.signaturePad.isEmpty() ? '' : this.signaturePad.toDataURL('image/png'));
    }

    clear = (e) => {
        e.preventDefault();
        this.signaturePad.clear();
        this.emit('');
    }

    emit(dataUrl) {
        if (this.props.onSignatureChange) {
            this.props.onSignatureChange(this.props.fieldId, this.props.fieldName, dataUrl);
        }
    }

    render() {
        return (
            <div className="signature-field">
                <canvas
                    ref={this.canvasRef}
                    id={'form-field-' + this.props.fieldId}
                    width="400"
                    height="150"
                    className="signature-canvas"
                    role="img"
                    aria-label={(this.props.fieldName || 'Signature') + ' signature pad'}
                ></canvas>
                <div className="signature-actions">
                    <button type="button" className="signature-clear-btn" onClick={this.clear}>Clear</button>
                </div>
            </div>
        );
    }
}

export default SignatureField;
